module.exports = __webpack_public_path__ + "static/gears-21d1457ea6443a512524d76e15220f22.jpg";